import React from 'react';
import '../assets/css/entete.css'
import { connect } from 'react-redux';
import LegendeCouche from './LegendeCouche';
import LegendePopup from './LegendePopup';

const Entete = ({ listecontenu }) => {
    let images = require.context('../assets/pictos', true);
    return <div className="entete">
        {
            listecontenu ?
                Object.values(listecontenu).map((e, id) => {
                    let itemImg = images(`./${e.picto}`);
                    return e.popup ?
                        <LegendePopup id={id} item={e} itemImg={itemImg} key={id} />
                        :
                        <LegendeCouche id={id} item={e} itemImg={itemImg} key={id} />
                })
                :
                null
        }
    </div>;
}

function mapStateToProps(state) {
    return {
        listecontenu: state.contenu
    }
}

export default connect(mapStateToProps, null)(Entete);